import {Component} from '@angular/core';
import {AutomationRoutes} from "../x-models/x-enums/automation-routes";
import {AppRoutes} from "../../../enums/routes";
import {PermissionService} from "../../../_auth/permission.service";
import {
  NavbarItemLargeComponent
} from "../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {CommonModule} from "@angular/common";
import {NavbarContainerComponent} from "../../../x-components/navbar-base/navbar-container/navbar-container.component";

@Component({
  selector: 'app-navbar-automation',
  templateUrl: './navbar-automation.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-automation.component.scss']
})
export class NavbarAutomationComponent {
  protected readonly AutomationRoutes = AutomationRoutes;
  protected readonly Routes = AppRoutes;

  constructor(public PermissionService: PermissionService) {
  }
}
